import { createRouter, createWebHistory } from 'vue-router';
import Home from '../views/Home.vue';
import Login from '../views/Login.vue';
import Staking from '../views/Staking';
import ApiService from '../services';
import Craft from '../views/Craft.vue';
import Mission from '../views/Mission.vue';
import mainView from '../components/Main';
const routes = [
  {
    path: '/',
    redirect: '/dashboard',
    component: mainView,
    // dashboard auth guard
    beforeEnter(to, from, next) {
      if (!isLogin()) {
        next('/login');
      } else {
        next();
      }
    },
    children: [
      {
        path: '/dashboard',
        name: 'dashboard',
        props: true,
        component: Home,
        meta: { sideBarKey: 'Dashboard' },
      },
    ],
  },
  {
    path: '/staked',
    component: mainView,
    // dashboard auth guard
    beforeEnter(to, from, next) {
      if (!isLogin()) {
        next('/login');
      } else {
        next();
      }
    },
    children: [
      {
        path: '/staked',
        name: 'staked',
        component: Staking,
        meta: { sideBarKey: 'staked' },
      },
    ],
  },
  {
    path: '/craft',
    component: mainView,
    // dashboard auth guard
    beforeEnter(to, from, next) {
      if (!isLogin()) {
        next('/login');
      } else {
        next();
      }
    },
    children: [
      {
        path: '/craft',
        name: 'craft',
        component: Craft,
        meta: { sideBarKey: 'craft' },
      },
    ],
  },
  {
    path: '/mission',
    component: mainView,
    // dashboard auth guard
    beforeEnter(to, from, next) {
      if (!isLogin()) {
        next('/login');
      } else {
        next();
      }
    },
    children: [
      {
        path: '/mission',
        name: 'mission',
        component: Mission,
        meta: { sideBarKey: 'mission' },
      },
    ],
  },
  {
    path: '/login',
    name: 'Login',
    // props: false,
    component: Login,
  },
];
const isLogin = function () {
  return ApiService.isLogin();
};
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
